import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../../utils';
import { TicketInputTicketFragment } from './GetAllTicketNumbers';

const GetAllPerDiemTicketNumbersQuery = gql`
  query GetAllPerDiemTicketNumbers {
    per_diem_eligible_ticket_numbers {
      edges {
        node {
          ...TicketInputTicket
        }
      }
    }
  }
  ${TicketInputTicketFragment}
`;


const marshallData = ({ data, ownProps }) => {
  const tickets = querySelector(data, '$.per_diem_eligible_ticket_numbers.edges[*].node', []);
  return {
    ...ownProps,
    data,
    tickets,
  };
};

const queryGetAllPerDiemTicketNumbersData = graphql(GetAllPerDiemTicketNumbersQuery, { props: marshallData });

export const queryGetAllPerDiemTicketNumbersGQL = compose(queryGetAllPerDiemTicketNumbersData);
